export const isValidWebsiteUrl = (url: string) => {
    if (!url.trim()) return true;
    return url.startsWith('https://') || url.startsWith('http://');
};
